import React, { useCallback, useEffect, useState } from 'react';
import { Loader2, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../../context/AuthContext';

const feld = 'w-full px-3 py-2 border border-gray-300 rounded-[10px] text-sm';

const Baustein = ({ b, onDone }) => {
  const [f, setF] = useState({ titel: b?.titel || '', text: b?.text || '' });
  const neu = !b;
  const speichern = async () => {
    try { await (neu ? api.post('/textbausteine', f) : api.patch(`/textbausteine/${b.id}`, f)); toast.success('Gespeichert'); if (neu) setF({ titel: '', text: '' }); onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Speichern fehlgeschlagen'); }
  };
  const loeschen = async () => { if (!window.confirm(`„${b.titel}“ löschen?`)) return; await api.delete(`/textbausteine/${b.id}`); onDone(); };
  const id = b?.id || 'neu';
  return (
    <div className={`p-4 rounded-xl border ${neu ? 'border-dashed border-[#b8893d]/60' : 'border-gray-200'} space-y-2`} data-testid={`textbaustein-${id}`}>
      <input value={f.titel} onChange={(e) => setF({ ...f, titel: e.target.value })} placeholder="Titel" className={feld} data-testid={`textbaustein-titel-${id}`} />
      <textarea rows={neu ? 3 : 4} value={f.text} onChange={(e) => setF({ ...f, text: e.target.value })} placeholder="Text – Platzhalter {Name}, {Mandantennummer}, {Aktenzeichen}, {Mitarbeiter}" className={feld} data-testid={`textbaustein-text-${id}`} />
      <div className="flex gap-2">
        <button type="button" onClick={speichern} disabled={!f.titel.trim() || !f.text.trim()} className="h-8 px-3 rounded-[10px] bg-[#1B3A5C] text-white text-xs disabled:opacity-50" data-testid={`textbaustein-speichern-${id}`}>{neu ? 'Hinzufügen' : 'Speichern'}</button>
        {!neu && <button type="button" onClick={loeschen} className="h-8 px-2 text-rose-600" aria-label="Löschen" data-testid={`textbaustein-loeschen-${id}`}><Trash2 className="w-4 h-4" /></button>}
      </div>
    </div>
  );
};

export const TextbausteineVerwaltung = () => {
  const [items, setItems] = useState(null);
  const load = useCallback(() => api.get('/textbausteine').then((r) => setItems(r.data.items || [])).catch(() => setItems([])), []);
  useEffect(() => { load(); }, [load]);
  if (!items) return <Loader2 className="w-5 h-5 animate-spin text-[#b8893d]" />;
  return (
    <div className="grid md:grid-cols-2 gap-3" data-testid="textbausteine-verwaltung">
      <Baustein onDone={load} />
      {items.map((b) => <Baustein key={`${b.id}-${b.updated_at}`} b={b} onDone={load} />)}
    </div>
  );
};
